import type React from 'react';

import { Button, Text } from '@change/ds-core-ui';

import { Translate, TranslateHtml } from '@change-corgi/core-react/i18n';

import { useHero } from './hooks/useHero';

export const Hero: React.FC = () => {
	const { actions } = useHero();

	return (
		<section id="hero" className="py-16 lg:py-24">
			<div className="container">
				<div className="flex max-w-3xl flex-col gap-5">
					<Text
						as="span"
						variant="body"
						size="small"
						fontWeight="bold"
						className="text-stroke-brand-strong tracking-wide uppercase"
					>
						<Translate value="corgi.ambassadors.hero.eyebrow" />
					</Text>
					<Text as="h1" variant="heading" size="x-large" className="text-typography-strong">
						<Translate value="corgi.ambassadors.hero.title" />
					</Text>
					<Text as="p" variant="body" size="large" className="text-typography-weak max-w-xl">
						<TranslateHtml value="corgi.ambassadors.hero.subtitle" />
					</Text>
					<div>
						<Button variant="primary" onClick={actions.handleCtaClick} data-qa="ambassadors-hero-cta">
							<Translate value="corgi.ambassadors.hero.cta" />
						</Button>
					</div>
				</div>
			</div>
		</section>
	);
};
